import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, useMemo } from 'react';
import "./Child.css";
import Toolbar from './';
import { EditorContext } from '../../Context';
export default function Child(props) {
  var _ref = props || {},
    prefixCls = _ref.prefixCls,
    groupName = _ref.groupName,
    commands = _ref.commands,
    children = _ref.children;
  var _useContext = useContext(EditorContext),
    _useContext$barPopup = _useContext.barPopup,
    barPopup = _useContext$barPopup === void 0 ? {} : _useContext$barPopup;
  return useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-toolbar-child ").concat(groupName && barPopup[groupName] ? 'active' : ''),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, Array.isArray(commands) ? /*#__PURE__*/React.createElement(Toolbar, _extends({
      commands: commands
    }, props)) : children);
  }, [commands, barPopup, groupName, prefixCls]);
}